$(document).ready(function() {

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  let collectionView = getCookie("collectionview");

  if (collectionView == "list") {
    $('.product-grid-container').addClass('list-view');
    $('#collection-list-view').addClass('active');
    $('#collection-grid-view').removeClass('active');
  } else {
    $('#collection-grid-view').addClass('active');
    $('#collection-list-view').removeClass('active');
    $('.product-grid-container').removeClass('list-view');
  }

  $('#collection-grid-view').click(function() {
    console.log('Grid View');
    $('.product-grid-container').removeClass('list-view');
    $('#collection-list-view').removeClass('active');
    $('#collection-grid-view').addClass('active');
    document.cookie = "collectionview=grid";
  });

  $('#collection-list-view').click(function() {
    console.log('List View');
    $('.product-grid-container').addClass('list-view');
    $('#collection-list-view').addClass('active');
    $('#collection-grid-view').removeClass('active');
    document.cookie = "collectionview=list";
  });


  $('form .custom-qty .minus').click(function() {
    console.log('minus!');
    var qty = $(this).siblings('#quantity');
    var currentQty = +qty.val();
    var newQty = currentQty - 1;
    var qtyMin = qty.attr('min');
    var qtyMax = qty.attr('max');
    console.log('The min is ' + qtyMin + ' and the max is ' + qtyMax + '. Old qty is' + currentQty + ', new qty is ' + newQty);
    if (currentQty > qtyMin) {
      console.log('Subtract One')
      qty.val(newQty);
    } else {
      console.log('Already at minimum!');
      return
    }
    
  })

  $('form .custom-qty .plus').click(function() {
    console.log('plus!');
    var qty = $(this).siblings('#quantity');
    var currentQty = +qty.val();
    var newQty = currentQty + 1;
    var qtyMin = qty.attr('min');
    var qtyMax = qty.attr('max');
    console.log('The min is ' + qtyMin + ' and the max is ' + qtyMax + ' . Old qty is' + currentQty + ', new qty is ' + newQty);
    if (currentQty < qtyMax) {
      console.log('Add One')
      qty.val(newQty);
    } else {
      console.log('Already at maximum!');
      return
    }
  })

  
})